export default __webpack_public_path__ + "static/media/error404.903f0d2a.png";